(() => {
  const correctedLabel = document.currentScript.dataset.correctedLabel;
  const root = window.Shopify?.routes?.root || '/';
  const collectionLinks = {
    'Accessories & Gifts': `${root}collections/accessories-gifts`,
    Brand: `${root}collections/shop-by-brand`,
  };

  function initialize() {
    const header = document.querySelector('header');
    if (!header || !correctedLabel) return;

    function correctLabels() {
      header.querySelectorAll('.tmenu_item_level_0 > .tmenu_item_link').forEach((link) => {
        const destination = collectionLinks[link.getAttribute('title')];
        if (destination && link.getAttribute('href') !== destination) link.setAttribute('href', destination);
      });
      header.querySelectorAll('.tmenu_item_text').forEach((label) => {
        if (label.textContent.trim() !== 'Collectons') return;
        label.textContent = correctedLabel;
        const link = label.closest('a');
        if (!link) return;
        ['title', 'aria-label'].forEach((attribute) => {
          if (link.getAttribute(attribute) === 'Collectons') {
            link.setAttribute(attribute, correctedLabel);
          }
        });
      });
    }

    header.addEventListener('click', (event) => {
      if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      if (!(event.target instanceof Element) || event.target.closest('.tmenu_indicator')) return;
      const link = event.target.closest('.tmenu_item_level_0 > .tmenu_item_link');
      if (!link || !collectionLinks[link.getAttribute('title')]) return;
      event.preventDefault();
      event.stopPropagation();
      window.location.assign(link.href);
    }, true);

    correctLabels();
    new MutationObserver(correctLabels).observe(header, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
